import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { Footer } from './components/footer/footer';
import { Header } from './components/header/header';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnDestroy {
  private readonly navSub: Subscription;

  constructor(private readonly router: Router) {
    this.navSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.split('?')[0].split('#')[0];
        if (url !== '/') {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.navSub.unsubscribe();
  }
}
